import React, { Component } from 'react';
import locale from 'util/locale';
import styles from './ResetPassword.module.scss';
import qs from 'qs';
import MobileDesktopRender from 'ui/MobileDesktopRender';
import OnboardNav from './../_OnboardNav';
import Box from './../_Box';
import ErrorBox from './../_ErrorBox';
import { Form, FormRow, FormColumn, FormLabel, TextInput } from 'ui/Form';
import { Button } from 'ui/Button';
import { connect, actions } from 'util/redux';

class ResetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        password: '',
      },
      errors: {},
      isSaving: false,
      showMessage: false,
    };
  }

  _changeData = (key, value) => {
    this.setState({
      data: {
        ...this.state.data,
        [key]: value,
      },
    });
  };

  _resetPassword = () => {
    const { resetPassword, token } = this.props;
    const { data } = this.state;

    this.setState({ isSaving: true, showMessage: false, errors: {} });
    resetPassword({ ...data, token })
      .then(() => {
        this.setState({ isSaving: false, showMessage: true });
      })
      .catch(response => {
        console.error(response);
        if (response.isValidationError && response.isValidationError()) {
          this.setState({
            errors: response.validationErrors().errorPerField(),
          });
        } else if (response.isNotFound && response.isNotFound()) {
          this.setState({
            errors: {
              _global: locale().onboard.reset_password_invalid_link_error,
            },
          });
        } else if (response.isBadRequest && response.isBadRequest()) {
          this.setState({
            errors: {
              _global: locale().onboard.reset_password_link_expired_error,
            },
          });
        } else {
          this.setState({
            errors: {
              _global: locale().system.global_error,
            },
          });
        }
        this.setState({ isSaving: false });
      });
  };

  _globalError = () => <ErrorBox>{this.state.errors._global}</ErrorBox>;

  _successMessage = () => (
    <div className={styles['success']}>
      {locale().onboard.reset_password_successful_info}
    </div>
  );

  _form = () => {
    const { data, errors, isSaving } = this.state;

    return (
      <Form onSubmit={this._resetPassword}>
        <FormRow>
          <FormColumn>
            <FormLabel
              value={locale().onboard.new_password}
              error={errors.password}
            />
            <TextInput
              value={data.password}
              onChange={value => this._changeData('password', value)}
              type={'password'}
            />
          </FormColumn>
        </FormRow>
        <div className={styles['action']}>
          <Button
            value={locale().actions.save}
            type={'submit'}
            disabled={isSaving}
            fill={true}
          />
        </div>
      </Form>
    );
  };

  _mobile = () => {
    const { showMessage } = this.state;

    let body;
    if (showMessage) {
      body = this._successMessage();
    } else {
      body = (
        <React.Fragment>
          {this._globalError()}
          {this._form()}
        </React.Fragment>
      );
    }

    return <div className={styles['mobileWrapper']}>{body}</div>;
  };

  _desktop = () => {
    const { showMessage } = this.state;

    if (showMessage) {
      return <Box>{this._successMessage()}</Box>;
    } else {
      return (
        <Box
          header={locale().onboard.reset_password_head}
          intro={locale().onboard.reset_password_intro}
        >
          {this._globalError()}
          {this._form()}
        </Box>
      );
    }
  };

  render() {
    const { openLoginPage } = this.props;

    return (
      <React.Fragment>
        <OnboardNav
          actionQuestion={locale().onboard.know_password_question}
          actionTitle={locale().actions.log_in}
          action={openLoginPage}
        />
        <MobileDesktopRender mobile={this._mobile} desktop={this._desktop} />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let searchQ = (ownProps.location.search || '').substring(1);
  const rawQuery = qs.parse(searchQ);

  return {
    token: rawQuery.token,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    openLoginPage: () => dispatch(actions.openLoginPage()),
    resetPassword: email => dispatch(actions.resetPassword(email)),
  };
};

ResetPassword = connect(mapStateToProps, mapDispatchToProps)(ResetPassword);

export default ResetPassword;
